/**
 * Turns header text from the API config form into a string map.
 * Accepts strict JSON and the unquoted object pasted from existing configs.
 */
export function parseApiHeaders(raw) {
  const text = String(raw || '').trim();
  if (!text) return {};

  try {
    const parsed = JSON.parse(text);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      throw new Error('Headers devem ser um objeto');
    }
    return stringifyHeaderValues(parsed);
  } catch (error) {
    if (error.message === 'Headers devem ser um objeto') throw error;
  }

  const body = text.replace(/^\s*\{/, '').replace(/\}\s*$/, '').trim();
  if (!body) return {};

  const headers = {};
  for (const entry of splitHeaderEntries(body)) {
    const separator = entry.indexOf(':');
    if (separator <= 0) {
      throw new Error('Headers devem ser um objeto');
    }
    const key = unquote(entry.slice(0, separator));
    const value = unquote(entry.slice(separator + 1));
    if (!key || !value) {
      throw new Error('Headers devem ser um objeto');
    }
    headers[key] = value;
  }

  if (Object.keys(headers).length === 0) {
    throw new Error('Headers devem ser um objeto');
  }

  return headers;
}

/** Copies header values as strings so tokens are never treated as numbers. */
function stringifyHeaderValues(record) {
  const headers = {};
  Object.entries(record).forEach(([key, value]) => {
    if (value == null || String(key).trim() === '') return;
    headers[String(key)] = typeof value === 'string' ? value : String(value);
  });
  return headers;
}

/** Splits "key: value" pairs on commas that are outside quotes. */
function splitHeaderEntries(body) {
  const parts = [];
  let current = '';
  let quote = null;

  for (let index = 0; index < body.length; index += 1) {
    const char = body[index];
    if (quote) {
      current += char;
      if (char === quote && body[index - 1] !== '\\') quote = null;
      continue;
    }
    if (char === '"' || char === "'") {
      quote = char;
      current += char;
      continue;
    }
    if (char === ',') {
      if (current.trim()) parts.push(current);
      current = '';
      continue;
    }
    current += char;
  }

  if (current.trim()) parts.push(current);
  return parts;
}

/** Removes wrapping quotes from a header key or value. */
function unquote(value) {
  const trimmed = value.trim().replace(/,\s*$/, '');
  const quoted = (
    (trimmed.startsWith('"') && trimmed.endsWith('"'))
    || (trimmed.startsWith("'") && trimmed.endsWith("'"))
  );
  return quoted ? trimmed.slice(1, -1) : trimmed;
}
